import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import SurveyIcon from '../SurveyIcon';

const baseSize = 32;
const selectedSize = baseSize * 1.25;
// const inactiveSize = baseSize * 0.65;
const svgCanvasSize = 64;

const Marker = ({ color, isValid, onClick, selected, shape, style, x, y }) => {
  const size = selected ? selectedSize : baseSize;
  const radius = size / 2;
  return (
    <span
      className={classnames('heatmap-click', {
        'heatmap-click--done anim-ripple anim-bounce': true,
        // 'o-50': !active,
      })}
      onClick={onClick}
      style={{
        color,
        cursor: 'pointer',
        position: 'absolute',
        left: `${x}%`,
        top: `${y}%`,
        transform: `translate(${-radius}px, ${-radius}px)`,
        width: size + 'px',
        height: size + 'px',
        zIndex: selected ? 20 : null,
        ...style,
      }}
    >
      <MarkerIcon
        className={classnames('animated', { bounceIn: true })}
        radius={radius}
        shape={shape}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      <ValidBadge isValid={isValid} />
    </span>
  );
};

Marker.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  hasNote: PropTypes.bool,
  isValid: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  shape: PropTypes.string,
  style: PropTypes.object,
  x: PropTypes.number,
  y: PropTypes.number,
};

export default Marker;

Marker.defaultProps = {
  color: 'red',
};

//

const ValidBadge = ({ isValid }) =>
  isValid ? null : (
    <span
      className="c-white bc-red"
      style={{
        height: '1.75em',
        width: '1.75em',
        lineHeight: '1.75em',
        textAlign: 'center',
        fontSize: '10px',
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        borderRadius: '50%',
      }}
    >
      <SurveyIcon width="10" height="10" icon="warning" />
    </span>
  );

ValidBadge.propTypes = {
  isValid: PropTypes.bool,
};

//

export class MarkerIcon extends PureComponent {
  render() {
    const { className, color, onClick, radius, shape, style } = this.props;
    return (
      <SurveyIcon
        className={className}
        icon={shape}
        onClick={onClick}
        width={radius * 2}
        height={radius * 2}
        style={{
          color,
          ...style,
        }}
      />
    );
  }
}

MarkerIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  radius: PropTypes.number,
  shape: PropTypes.string,
  style: PropTypes.object,
};

class Smile extends PureComponent {
  render() {
    const radius = svgCanvasSize / 2;
    return (
      <g fill="none">
        <circle
          style={{ fill: 'currentcolor' }}
          cx={radius}
          cy={radius}
          r={radius}
        />
        <path
          d="M27.977 26.225c.015-.239.023-.48.023-.725 0-4.142-2.239-7.5-5-7.5s-5 3.358-5 7.5c0 .245.008.486.023.725 1.142-1.2 2.946-1.975 4.977-1.975 2.03 0 3.835.775 4.977 1.975zM45.977 26.225c.015-.239.023-.48.023-.725 0-4.142-2.239-7.5-5-7.5s-5 3.358-5 7.5c0 .245.008.486.023.725 1.142-1.2 2.946-1.975 4.977-1.975 2.03 0 3.835.775 4.977 1.975z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
        <path
          d="M48 41c-2.467 5.275-8.477 9-15.5 9S19.467 46.275 17 41c3.861 2.822 9.376 4.589 15.5 4.589 6.124 0 11.639-1.767 15.5-4.589z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}

class Frown extends PureComponent {
  render() {
    const radius = svgCanvasSize / 2;
    return (
      <g fill="none">
        <circle
          style={{ fill: 'currentcolor' }}
          cx={radius}
          cy={radius}
          r={radius}
        />
        <path
          d="M26.41 17.863c.374.913.59 1.987.59 3.137 0 3.314-1.79 6-4 6s-4-2.686-4-6c0-1.384.312-2.658.837-3.673 2.09.242 4.29.423 6.573.536zm17.753-.536c.525 1.015.837 2.29.837 3.673 0 3.314-1.79 6-4 6s-4-2.686-4-6c0-1.15.216-2.224.59-3.137 2.283-.113 4.484-.294 6.573-.536z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
        <path
          d="M17 47c2.467-5.275 8.477-9 15.5-9s13.033 3.725 15.5 9c-3.861-2.822-9.376-4.589-15.5-4.589-6.124 0-11.639 1.767-15.5 4.589z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}

class Neutral extends PureComponent {
  render() {
    const radius = svgCanvasSize / 2;
    return (
      <g fill="none">
        <circle
          style={{ fill: 'currentcolor' }}
          cx={radius}
          cy={radius}
          r={radius}
        />
        <path
          d="M23 27c2.21 0 4-2.686 4-6s-1.79-6-4-6-4 2.686-4 6 1.79 6 4 6zm18 0c2.21 0 4-2.686 4-6s-1.79-6-4-6-4 2.686-4 6 1.79 6 4 6zM26 41h11v4H26z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}

class Circle extends PureComponent {
  render() {
    const radius = svgCanvasSize / 2;
    return (
      <circle
        cx={radius}
        cy={radius}
        r={radius}
        style={{
          fill: 'currentcolor',
        }}
      />
    );
  }
}

export const starPath =
  'M62.52 21.984l-22.076-1.43L32.263 0 24.08 20.554 2 21.984l17.025 14.132-5.463 21.438 18.7-11.82 18.701 11.82L45.5 36.116z';
class Star extends PureComponent {
  render() {
    return <path d={starPath} style={{ fill: 'currentcolor' }} />;
  }
}

export const squarePath = 'M9 9h47v47H9z';
class Square extends PureComponent {
  render() {
    return <path d={squarePath} style={{ fill: 'currentcolor' }} />;
  }
}

export const diamondPath = 'M 32 .2 L 63.8 32 L 32 63.8 L .2 32 L 32 .2 z';
class Diamond extends PureComponent {
  render() {
    return <path d={diamondPath} style={{ fill: 'currentcolor' }} />;
  }
}

export const trianglePath = 'M32 0l32 51H0z';
class Triangle extends PureComponent {
  render() {
    return <path d={trianglePath} style={{ fill: 'currentcolor' }} />;
  }
}

export const shapes = [
  'smile',
  'neutral',
  'frown',
  'circle',
  'diamond',
  'star',
  'square',
  'triangle',
];

const shapeMap = {
  circle: Circle,
  diamond: Diamond,
  frown: Frown,
  neutral: Neutral,
  star: Star,
  smile: Smile,
  square: Square,
  triangle: Triangle,
};
